import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["transitionEnd", "transition"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useContext } from 'react';
import { isAnimationControls } from '../../animation/utils/is-animation-controls.mjs';
import { MotionContext } from '../../context/MotionContext/index.mjs';
import { PresenceContext } from '../../context/PresenceContext.mjs';
import { isControllingVariants, isVariantNode } from '../../render/utils/is-controlling-variants.mjs';
import { resolveVariantFromProps } from '../../render/utils/resolve-variants.mjs';
import { useConstant } from '../../utils/use-constant.mjs';
import { resolveMotionValue } from '../../value/utils/resolve-motion-value.mjs';
function makeState(_ref, props, context, presenceContext) {
  var scrapeMotionValuesFromProps = _ref.scrapeMotionValuesFromProps,
    createRenderState = _ref.createRenderState,
    onUpdate = _ref.onUpdate;
  var state = {
    latestValues: makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
    renderState: createRenderState()
  };
  if (onUpdate) {
    /**
     * onMount works without the VisualElement because it could be
     * called before the VisualElement payload has been hydrated.
     * (e.g. if someone is using m components <m.circle />)
     */
    state.onMount = function (instance) {
      return onUpdate(_objectSpread({
        props: props,
        current: instance
      }, state));
    };
    state.onUpdate = function (visualElement) {
      return onUpdate(visualElement);
    };
  }
  return state;
}
var makeUseVisualState = function makeUseVisualState(config) {
  return function (props, isStatic) {
    var context = useContext(MotionContext);
    var presenceContext = useContext(PresenceContext);
    var make = function make() {
      return makeState(config, props, context, presenceContext);
    };
    return isStatic ? make() : useConstant(make);
  };
};
function makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
  var values = {};
  var motionValues = scrapeMotionValues(props, {});
  for (var key in motionValues) {
    values[key] = resolveMotionValue(motionValues[key]);
  }
  var initial = props.initial,
    animate = props.animate;
  var isControllingVariants$1 = isControllingVariants(props);
  var isVariantNode$1 = isVariantNode(props);
  if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
    if (initial === undefined) initial = context.initial;
    if (animate === undefined) animate = context.animate;
  }
  var isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
  isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
  var variantToSet = isInitialAnimationBlocked ? animate : initial;
  if (variantToSet && typeof variantToSet !== "boolean" && !isAnimationControls(variantToSet)) {
    var list = Array.isArray(variantToSet) ? variantToSet : [variantToSet];
    for (var i = 0; i < list.length; i++) {
      var resolved = resolveVariantFromProps(props, list[i]);
      if (resolved) {
        var transitionEnd = resolved.transitionEnd,
          transition = resolved.transition,
          target = _objectWithoutProperties(resolved, _excluded);
        for (var _key in target) {
          var valueTarget = target[_key];
          if (Array.isArray(valueTarget)) {
            /**
             * Take final keyframe if the initial animation is blocked because
             * we want to initialise at the end of that blocked animation.
             */
            var index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
            valueTarget = valueTarget[index];
          }
          if (valueTarget !== null) {
            values[_key] = valueTarget;
          }
        }
        for (var _key2 in transitionEnd) {
          values[_key2] = transitionEnd[_key2];
        }
      }
    }
  }
  return values;
}
export { makeUseVisualState };